import { BaseApplication } from '../../shared/enums/base-application.enum';
import { BaseEnvironment } from '../../shared/enums/base-environment.enum';

enum DemoUrls {
  businessDev = 'http://localhost:4200',
  medicalDev = 'http://localhost:4201',
  growthDev = 'http://localhost:4202',
  feltenDev = 'http://localhost:4203',
  medicalDemo = 'app-demo.stazzle-medical.de',
  businessDemo = 'app-demo.stazzle-business.de',
  growthDemo = 'app-demo.stazzle-growth.de',
  medicalProd = 'app.stazzle-medical.de',
  feltenProd = 'einsatzportal.felten.de',
  businessProd = 'app.stazzle-business.de',
  growthProd = 'app.stazzle-growth.de',
  medicalStage = 'stazzle-medical.applicants.live',
  feltenStage = 'felten.applicants.live',
  businessStage = 'stazzle-business.applicants.live',
  growthStage = 'stazzle-growth.applicants.live',
}

export class EnvironmentUtils {
  static getEnvironment(): BaseEnvironment {
    let environment = BaseEnvironment.dev;
    if (window && window.location && window.location.hostname) {
      const hostname = window.location.hostname.toLowerCase();
      const demoHosts = [DemoUrls.medicalDemo, DemoUrls.businessDemo, DemoUrls.growthDemo];
      const liveHosts = [DemoUrls.medicalProd, DemoUrls.feltenProd, DemoUrls.businessProd, DemoUrls.growthProd];
      const stageHosts = [DemoUrls.medicalStage, DemoUrls.feltenStage, DemoUrls.businessStage, DemoUrls.growthStage];

      if (liveHosts.indexOf(hostname as DemoUrls) !== -1) {
        environment = BaseEnvironment.prod;
      } else if (stageHosts.indexOf(hostname as DemoUrls) !== -1) {
        environment = BaseEnvironment.stage;
      } else if (demoHosts.indexOf(hostname as DemoUrls) !== -1) {
        environment = BaseEnvironment.demo;
      }
    }

    return environment;
  }

  public static getStazzleBaseUrl(application: BaseApplication): string {
    const hostname = application === BaseApplication.medical ? window?.location?.hostname?.toLowerCase() : undefined;

    return EnvironmentUtils.getApplicationDomain(this.getEnvironment(), application, hostname);
  }

  public static getSentryXhrLogging(): boolean {
    // privacy protection remove xhr logging in production (live env)
    return EnvironmentUtils.getEnvironment() !== 'prod';
  }

  public static getSentryHistoryLogging(): boolean {
    // privacy protection remove history logging in production (live env)
    return EnvironmentUtils.getEnvironment() !== 'prod';
  }

  private static getApplicationDomain(
    environment: BaseEnvironment,
    application: BaseApplication,
    hostname?: string
  ): string {
    const urlPrefix = 'https://';

    if (environment === BaseEnvironment.dev) {
      if (application === BaseApplication.medical) {
        return !!hostname ? DemoUrls.feltenDev : DemoUrls.medicalDev;
      }

      switch (application) {
        case BaseApplication.growth:
          return DemoUrls.growthDev;
        case BaseApplication.business:
          return DemoUrls.businessDev;
        default:
          return DemoUrls.medicalDev;
      }
    }

    if (environment === BaseEnvironment.demo) {
      switch (application) {
        case BaseApplication.medical:
        default:
          return `${urlPrefix}${DemoUrls.medicalDemo}`;
        case BaseApplication.growth:
          return `${urlPrefix}${DemoUrls.growthDemo}`;
        case BaseApplication.business:
          return `${urlPrefix}${DemoUrls.businessDemo}`;
      }
    }

    if (environment === BaseEnvironment.prod) {
      if (application === BaseApplication.medical) {
        return hostname === DemoUrls.feltenProd
          ? `${urlPrefix}${DemoUrls.feltenProd}`
          : `${urlPrefix}${DemoUrls.medicalProd}`;
      }

      switch (application) {
        case BaseApplication.growth:
          return `${urlPrefix}${DemoUrls.growthProd}`;
        case BaseApplication.business:
          return `${urlPrefix}${DemoUrls.businessProd}`;
        default:
          return `${urlPrefix}${DemoUrls.medicalProd}`;
      }
    }

    if (environment === BaseEnvironment.stage) {
      if (application === BaseApplication.medical) {
        return hostname === DemoUrls.feltenStage
          ? `${urlPrefix}${DemoUrls.feltenStage}`
          : `${urlPrefix}${DemoUrls.medicalStage}`;
      }

      switch (application) {
        case BaseApplication.growth:
          return `${urlPrefix}${DemoUrls.growthStage}`;
        case BaseApplication.business:
          return `${urlPrefix}${DemoUrls.businessStage}`;
        default:
          return `${urlPrefix}${DemoUrls.medicalStage}`;
      }
    }

    // Backup domain
    return `${urlPrefix}${DemoUrls.medicalStage}`;
  }
}
